import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import DragSource from "react-dnd/lib/DragSource";
import { Icon } from "signoxe/components/widgets";
import { AssetPreview } from "..";
import { AssetPropType } from "../../constants/propTypes";
import "./styles.scss";

class CampaignDraggable extends React.Component {
  static propTypes = {
    asset: AssetPropType,
    connectDragSource: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,
    selected: PropTypes.bool,
    onTap: PropTypes.func.isRequired,
  };

  // handleTouchTap = () => {
  //   this.props.onTap(this.props.asset);
  // };

  render() {
    const { isDragging, connectDragSource, asset, selected, onCampaignClick } =
      this.props;
    const assetType = (asset.type || "").toLowerCase();

    return connectDragSource(
      <div
        className={classNames("draggable-asset CampaignDraggable", "depth-1", {
          dragging: isDragging,
          selected,
        })}
        // onTouchTap={this.handleTouchTap}
        onClick={() => onCampaignClick(asset)}
      >
        <div className="asset-name">{asset.name}</div>
        <Icon title="folder" name="folder" size="2.25rem" color="black" />
        {/* <AssetPreview asset={asset} /> */}
        <div className={classNames("type", assetType)}>{asset.type}</div>
      </div>
    );
  }
}

const AssetSource = {
  beginDrag(props) {
    console.log(" beginDrag Campaign Drag props.asset = ", props.asset.assets);
    return { asset: props.asset.assets };
  },
};

const makeSource = DragSource(
  "ASSET_TYPE",
  AssetSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })
);

export default makeSource(CampaignDraggable);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/CampaignDraggable/index.js